export default {
  name: 'marking--erpKM',
  apiService: 'shoes',
  apiPath: '/admin/doc_erp_km',
};